import React, { useEffect, useState } from 'react';
import './DonationSection.css';
import { getStorage, ref, listAll, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

const Donation = () => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      const storageRef = ref(storage, 'Donations');
      const result = await listAll(storageRef);
      const urlPromises = result.items.map((imageRef) => getDownloadURL(imageRef));

      const urls = await Promise.all(urlPromises);
      setImages(urls);
    };

    fetchImages();
  }, []);

  const openLightbox = (src) => {
    setSelectedImage(src);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };
  return (
    <div className="donation-section">
      <div className="donation-title">
        <h4>DONATION</h4>
        <div class="title-underline-donation"></div>
      </div>

      <div className="donation-images-container">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            768: {
              slidesPerView: 1,
            },
            1100: {
              slidesPerView: 2,
            },
          }}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="donation-image-container" onClick={() => openLightbox(image)}>
                <img src={image} alt={`Donation ${index + 1}`} className="donation-image" />
              </div>
            </SwiperSlide>
          ))}
          {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Enlarged" />
          </div>
        </div>
      )}
        </Swiper>
      </div>
    </div>
  );
};

export default Donation;
